import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import { cn } from '~/utils/cn'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import i18n from '~/i18n'

const BUTTON_STYLE_PRESETS = ['primary', 'secondary', 'tertiary']
const FONT_STYLE_PRESETS = ['h1', 'h2', 'h3', 'h4', 'p']

function capitalize(value) {
    const text = String(value || '')
    if (!text) return text
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

function fontStyleSubCategory(value) {
    return String(value || '').toUpperCase()
}

export default class ComponentSelect extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this)
    }

    change(event) {
        var thisVal = String(event.currentTarget.value)
        this.props.updateVal(this.props.path, thisVal)
    }

    render() {
        var thisOptions = this.props.options
        let isFontSelect = thisOptions === '[OPTIONS.FONTARRAY]'
        if (thisOptions && typeof thisOptions != 'object') {
            if (thisOptions.indexOf('OPTIONS') > 0) {
                thisOptions = DragDropFunctions.lookupVariables(thisOptions)
            }
        }

        var style = this.props.style || {}
        if (this.props.elementData.optionFullWidth) style = { width: '100%' }

        var thisVal = this.props.value
        if (thisVal == 'arial') thisVal = 'Arial'

        thisOptions = thisOptions.map((o) => {
            if (typeof o !== 'object') {
                return { label: String(o), value: String(o) }
            }
            return {
                label: String(o.newLabel || o.label),
                value: String(o.value),
                iconLeft: o.icon,
                illustration: o.illustration,
                sublabel: o.sublabel,
                group: o.group
            }
        })

        const path = String(this.props.path || '')
        const isButtonStyleSelect = path.endsWith('buttonStyle')
        const isFontStyleSelect = path.endsWith('headingType') || path.endsWith('textStyle')
        const canEditGlobalButtonStyle =
            isButtonStyleSelect &&
            BUTTON_STYLE_PRESETS.includes(String(thisVal).toLowerCase()) &&
            typeof this.props.openGlobalStyle === 'function'
        const canEditGlobalFontStyle =
            isFontStyleSelect &&
            FONT_STYLE_PRESETS.includes(String(thisVal).toLowerCase()) &&
            typeof this.props.openGlobalStyle === 'function'
        const canEditGlobalStyle = canEditGlobalButtonStyle || canEditGlobalFontStyle

        const editStyleLabel = canEditGlobalFontStyle
            ? i18n.t('templates:add.drag.style.editFontStyle')
            : i18n.t('templates:add.drag.style.editButtonStyle')
        const editStyleTestId = canEditGlobalFontStyle ? 'edit-font-style' : 'edit-button-style'
        const labelOptions = canEditGlobalStyle ? (
            <Icons
                icon='pencil'
                alt={editStyleLabel}
                data-tooltip-id={`${editStyleTestId}-tooltip`}
                data-tooltip-content={editStyleLabel}
                data-tooltip-position='bottom'
                data-test={editStyleTestId}
                outerStyle={{
                    width: 24,
                    height: 24,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                style={{ width: 15, height: 15 }}
                color='#0A0A0A'
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    this.props.openGlobalStyle(
                        canEditGlobalFontStyle
                            ? { category: 'Fonts', subCategory: fontStyleSubCategory(thisVal) }
                            : { category: 'Buttons', subCategory: capitalize(thisVal) }
                    )
                }}
            />
        ) : null

        return (
            <div
                className={cn(
                    'dndEditorv2-dd_toolHolder',
                    this.props.elementData.optionHalfWidth && 'dndEditorv2-dd_toolHolder-half'
                )}
                style={style}
            >
                <div className='dd_inputTool'>
                    <Select
                        className='dndEditorv2-select'
                        headerContentStyle={{ maxWidth: 450 }}
                        label={this.props.title}
                        labelOptions={labelOptions}
                        data={thisOptions}
                        onChange={this.change}
                        value={thisVal}
                        filter={isFontSelect}
                        orderGroups={true}
                        groupOrder={isFontSelect ? DragDropFunctions.FONT_SELECT_GROUP_ORDER : undefined}
                        showIcon={false}
                    />
                </div>
            </div>
        )
    }
}
